import * as React from "react";
import { SourceRequestOrder } from "../../Constant/Source";
import { ModelState } from "../../Models/ModelStateEnum";
import RbhRequestOrderCreate from "./RbhRequestOrderCreate";
import RbhRequestOrderView from "./RbhRequestOrderView";
import RbhRequestOrderUpdate from "./RbhRequestOrderUpdate";

const RequestOrderInfo = props => {
  switch (props.ModelState) {
    case ModelState.Create:
      return (
        <RbhRequestOrderCreate
          resource="requestorder"
          basePath={SourceRequestOrder}
          selectedData={props.selectedData}
        />
      );
    case ModelState.Edit:
      return <RbhRequestOrderUpdate />;
    default:
      return <RbhRequestOrderView DataSource={props.DataSource} />;
  }
};

export default RequestOrderInfo;
